import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteGendersMutationProps = {
	ids: number[]
	onSettled: () => void
}

export const useDeleteGendersMutation = ({ ids, onSettled }: UseDeleteGendersMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: deleteGendersMutation } = useMutation({
		mutationFn: () => axiosPrivate.post(apiRoutes.gendersDelete, { ids }),
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Genders deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.genders.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteGendersMutation
	}
}
